import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { UsersComponent } from './users/users.component';
import { SearchNamePipe } from './search-name.pipe';
import { RootSearchPipe } from './root-search.pipe';
import { ControlSearchPipe } from './control-search.pipe';
import { RootComponent } from './root/root.component';
import { RootSearchTypePipe } from './root-search-type.pipe';
import { SupsuppliersComponent } from './supsuppliers/supsuppliers.component';
import { ItemsComponent } from './items/items.component';
import { SerchCodePipe } from './serch-code.pipe';
import { CategoryComponent } from './category/category.component';
import { PaynoComponent } from './payno/payno.component';
import { QuotationComponent } from './quotation/quotation.component';
import { RequestComponent } from './request/request.component';
import { PlaceSearchPipe } from './place-search.pipe';
import { SerchCodeSupplierPipe } from './serch-code-supplier.pipe';
import { HistoryComponent } from './history/history.component';
import { NameSearchWhoPipe } from './name-search-who.pipe';
import { PaymentComponent } from './payment/payment.component';
import { PutmoneyComponent } from './putmoney/putmoney.component';
import { VisitComponent } from './visit/visit.component';
import { SearchSupplierPipe } from './search-supplier.pipe';
import { SheetComponent } from './sheet/sheet.component';
import { SelectpinPipe } from './selectpin.pipe';
import { SellerComponent } from './seller/seller.component';
import { BrokerComponent } from './broker/broker.component';
import { CustomerIdPipe } from './customer-id.pipe';
import { CategorySearchPipe } from './category-search.pipe';
import { OrderComponent } from './order/order.component';
import { StoreComponent } from './store/store.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ReturnComponent } from './return/return.component';
import { QuotationPipe } from './quotation.pipe';
import { ReportsComponent } from './reports/reports.component';
import { ClientVisetorComponent } from './client-visetor/client-visetor.component';
import { DateComPipe } from './date-com.pipe';
import { SamedatePipe } from './samedate.pipe';
import { QuotationBillPipe } from './quotation-bill.pipe';
import { IdCustomerPipe } from './id-customer.pipe';
import { EmployeeComponent } from './employee/employee.component';
import { Itemmin0Pipe } from './itemmin0.pipe';
import { AttendanceComponent } from './attendance/attendance.component';
import { SearchEmployeePipe } from './search-employee.pipe';
import { SalaryComponent } from './salary/salary.component';
import { From0Pipe } from './from0.pipe';
import { ItemSearchReqPipe } from './item-search-req.pipe';
import { To0Pipe } from './to0.pipe';
import { PermissionComponent } from './permission/permission.component';
import { Helpme } from './helpme';
import { ApiService } from './api.service';
// import { AccountsGuideComponent } from './accounts-guide/accounts-guide.component';
// import { CashPaymentsComponent } from './cash-payments/cash-payments.component';
import { AccountPipe } from './account.pipe';
import { AccountFilterPipe } from './account-filter.pipe';
import { SearchSubAccountPipe } from './search-sub-account.pipe';
// import { CashreceiptsComponent } from './cashreceipts/cashreceipts.component';
import { DailyrestrictionsComponent } from './dailyrestrictions/dailyrestrictions.component';
// import { GeneralReportsComponent } from './general-reports/general-reports.component';
import { AccountNamePipe } from './account-name.pipe';
import { AccountNameSubPipe } from './account-name-sub.pipe';
import { TypeAccountPipe } from './type-account.pipe';
import { PrivateReortComponent } from './private-reort/private-reort.component';
import { OrderOnlyPipe } from './order-only.pipe';
import { NoRepeatPipe } from './no-repeat.pipe';
import { AreaFilterPipe } from './area-filter.pipe';
import { DateComOrderPipe } from './date-com-order.pipe';
import { CountrySearchPipe } from './country-search.pipe';
import { CountrySearch1Pipe } from './country-search1.pipe';
import { NoRepeatAreaPipe } from './no-repeat-area.pipe';
import { PaymentsReportComponent } from './payments-report/payments-report.component';
import { AccountNametreasuryPipe } from './account-nametreasury.pipe';
import { FakePipe } from './fake.pipe';
import { PlaceSearchNotPipe } from './place-search-not.pipe';
import { DateComAnoterVersionPipe } from './date-com-anoter-version.pipe';
import { WaypayPipe } from './waypay.pipe';
import { FilterQtyPipe } from './filter-qty.pipe';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UsersComponent,
    SearchNamePipe,
    RootSearchPipe,
    ControlSearchPipe,
    RootComponent,
    RootSearchTypePipe,
    SupsuppliersComponent,
    ItemsComponent,
    SerchCodePipe,
    CategoryComponent,
    PaynoComponent,
    QuotationComponent,
    RequestComponent,
    PlaceSearchPipe,
    SerchCodeSupplierPipe,
    HistoryComponent,
    NameSearchWhoPipe,
    PaymentComponent,
    PutmoneyComponent,
    VisitComponent,
    SearchSupplierPipe,
    SheetComponent,
    SelectpinPipe,
    SellerComponent,
    BrokerComponent,
    CustomerIdPipe,
    CategorySearchPipe,
    OrderComponent,
    StoreComponent,
    ReturnComponent,
    QuotationPipe,
    ReportsComponent,
    ClientVisetorComponent,
    DateComPipe,
    SamedatePipe,
    QuotationBillPipe,
    IdCustomerPipe,
    EmployeeComponent,
    Itemmin0Pipe,
    AttendanceComponent,
    SearchEmployeePipe,
    SalaryComponent,
    From0Pipe,
    ItemSearchReqPipe,
    To0Pipe,
    PermissionComponent,
    // AccountsGuideComponent,
    // CashPaymentsComponent,
    AccountPipe,
    AccountFilterPipe,
    SearchSubAccountPipe,
    // CashreceiptsComponent,
    DailyrestrictionsComponent,
    // GeneralReportsComponent,
    AccountNamePipe,
    AccountNameSubPipe,
    TypeAccountPipe,
    PrivateReortComponent,
    OrderOnlyPipe,
    NoRepeatPipe,
    AreaFilterPipe,
    DateComOrderPipe,
    CountrySearchPipe,
    CountrySearch1Pipe,
    NoRepeatAreaPipe,
    PaymentsReportComponent,
    AccountNametreasuryPipe,
    FakePipe,
    PlaceSearchNotPipe,
    DateComAnoterVersionPipe,
    WaypayPipe,
    FilterQtyPipe
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    CommonModule,BrowserAnimationsModule,ToastrModule.forRoot(),
  ],
  providers: [{ provide: LocationStrategy , useClass:  HashLocationStrategy }, Helpme , SearchSupplierPipe , SelectpinPipe , DateComPipe , PlaceSearchPipe , SerchCodePipe , CustomerIdPipe , SamedatePipe  , OrderOnlyPipe , DateComOrderPipe , AreaFilterPipe , CategorySearchPipe , QuotationBillPipe , CountrySearchPipe , IdCustomerPipe , TypeAccountPipe , AccountNamePipe , AccountNameSubPipe , AccountNametreasuryPipe , DateComAnoterVersionPipe ],
  bootstrap: [AppComponent]
})
export class AppModule {}
